<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny">

            <BnFormField v-if="isSZGK()" :attributes="egyuttlakas"/>

            <BnFormField v-if="isSZGK()" :attributes="lakaspartner"/>

            <BnFormField v-if="isSZGK() || isMKP()" :attributes="egyuttcasco"/>

            <BnFormField v-if="isSZGK()" :attributes="egyuttelet"/>

            <BnFormField v-if="isSZGK()" :attributes="egyuttbaleset"/>

            <BnFormField v-if="isSZGK()" :attributes="vallvagyon"/>

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import { SZGK } from '../../../../../../../modules/Gepjarmu';

export default {
    name: 'KedvezmenyekB3',
    components: {
        KedvezmenyekBase,
        BnFormField,
    },
    mixins: [Kedvezmeny],
    methods: {
        egyuttlakasChange() {
            this.$store.commit('setProp', {
                value: false,
                path: 'kedvezmenyekbiztosito.3.lakaspartner',
            });
            this.shouldRecalc();
        },
        lakaspartnerChange() {
            this.$store.commit('setProp', {
                value: false,
                path: 'kedvezmenyekbiztosito.3.egyuttlakas',
            });
            this.shouldRecalc();
        },
    },
    data() {
        return {
            SZGK,
            egyuttlakas: {
                type: 'checkbox',
                label: 'Lakásbiztosítás együttkötési kedvezmény',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.3.egyuttlakas',
                mezo: 'aegon_egyuttlakas',
                help: true,
                change: this.egyuttlakasChange,
            },
            lakaspartner: {
                type: 'checkbox',
                label: 'Lakás partnerkedvezmény',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.3.lakaspartner',
                mezo: 'lakaspartner',
                help: true,
                change: this.lakaspartnerChange,
            },
            egyuttbaleset: {
                type: 'checkbox',
                label: 'Balesetbiztosítási együttkötési kedvezmény',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.3.egyuttbaleset',
                mezo: 'aegon_egyuttbaleset',
                help: true,
                change: this.shouldRecalc,
            },
            egyuttcasco: {
                type: 'checkbox',
                label: 'CASCO együttkötési kedvezmény',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.3.egyuttcasco',
                mezo: 'aegon_egyuttcasco',
                help: true,
                change: this.shouldRecalc,
            },
            egyuttelet: {
                type: 'checkbox',
                label: 'Életbiztosítási együttkötési kedvezmény',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.3.egyuttelet',
                mezo: 'aegon_egyuttelet',
                help: true,
                change: this.shouldRecalc,
            },
            vallvagyon: {
                type: 'checkbox',
                label: 'Vállalati vagyon együttk. kedvemény',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.3.vallvagyon',
                mezo: 'aegon_vallvagyon',
                help: true,
                change: this.shouldRecalc,
            },
            aegon_60km: {
                type: 'select',
                label: 'Ingázók korrekció',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekalaptabla.3.aegon_60km',
                mezo: '_aegon_aegon_60km',
                help: true,
                change: this.shouldRecalc,
                options: [
                    { key: 'N', value: 'Nem' },
                    {
                        key: 'Y',
                        value: 'Igen, a munkahely legfeljebb 60 km-re van az életvitel szerinti tartózkodási helyétől',
                    },
                    {
                        key: 'Y60',
                        value: 'Igen, a munkahely 60 km-nél messzebb van az életvitel szerinti tartózkodási helyétől',
                    },
                ],
                itemsText: 'value',
                itemsValue: 'key',
            },
        };
    },
};
</script>
